import { useContext, useEffect, useState } from "react";
import { Context } from "../../Context";
import { useParams } from "react-router-dom";
import "./style.scss";
import Loading from "../Loading";

function FinishedSurvey() {
  const { getLayout, server } = useContext(Context);
  const { carouselName } = useParams();
  const [layout, setLayout] = useState(null);

  const handleLayout = async () => {
    let layout = await getLayout(carouselName);
    setLayout(layout);
  };

  useEffect(() => {
    if (!layout) {
      handleLayout();
    }
  }, []);

  if (!layout) {
    return <Loading />;
  } else {
    return (
      <div
        className="compIntermediary"
        style={{ backgroundColor: layout?.general_layout_cabecalho_background }}
      >
        <div className="imgArea">
          <img
            src={`${
              server === "ai"
                ? "https://hazo.ai/dist/img/"
                : "https://hazo.me/dist/img/"
            }${layout.general_layout_cabecalho_logo}`}
            alt="avatar"
          />
          <img
            src={`${
              server === "ai"
                ? "https://hazo.ai/dist/img/"
                : "https://hazo.me/dist/img/"
            }${layout.general_layout_cabecalho_robo_logo}`}
            alt="avatar"
          />
        </div>
        <span style={{ color: layout.general_layout_cabecalho_text }}>
          Você não tem novas pesquisas disponíveis no momento.
          <br />
          Agradecemos pela sua colaboração!
          <br />
          Até breve! 😊
        </span>
      </div>
    );
  }
}

export default FinishedSurvey;
